import React, { Component } from "react"
import { translate } from "react-translate"
import Icon from "react-icons-kit"
import { calendar } from "react-icons-kit/fa/calendar"
import { Segment } from "semantic-ui-react"
import "./EnteteBody.css"

import ModalDevisDocument from "./ModalDevisDocument"

const EnteteBody = ({ dateEnteteBody, t, newDevis }) => (
  <Segment id="enteteBody">
    <h2 id="dateDF">
      <Icon size={24} id="icondateDF" icon={calendar} />
      {dateEnteteBody}
    </h2>{" "}
    <ModalDevisDocument
      newDevis={newDevis}
      id="creation"
      icons="plus circle"
      style="creation"
      text={t("button_entete_body_create")}
    />
  </Segment>
)

export default translate("ProDevisEnteteBody")(EnteteBody)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/BodyDevisEtFactures/EnteteBody.js